import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api-client';

import type { InvoiceDirection } from './use-applied-provisional';
import type { InvoiceRow } from '../types';

export function adjustableParentsKey(blOrderId: string | undefined, direction: InvoiceDirection) {
  return ['bl-order-adjustable-parents', blOrderId, direction] as const;
}

export function useAdjustableParents(blOrderId: string | undefined, direction: InvoiceDirection) {
  return useQuery<InvoiceRow[]>({
    queryKey: adjustableParentsKey(blOrderId, direction),
    enabled: blOrderId !== undefined && blOrderId.length > 0,
    queryFn: () =>
      apiRequest<InvoiceRow[]>(
        `/bl-orders/${encodeURIComponent(blOrderId ?? '')}/invoices/adjustable?direction=${direction}`,
      ),
  });
}
